export const SOCIAL_UPDATE_MESSAGE = 'social/UPDATE_MESSAGE';

// Update properties on message object without calling any API
export default (messageId, props) => ({
  type: SOCIAL_UPDATE_MESSAGE,
  messageId,
  props,
});
